'use strict';

import { graphql } from 'react-relay';

export const sbRespRoot = graphql`
    query sbRespRootQuery(
        $userId: String = ""
        $fetchUser: Boolean!
        $uriRef: String = ""
        $first: Int!
        $page: Int!
        $localeOrigin: String = ""
        $isTrade: Boolean!
        $showSeller: Boolean!
        $followSearchPages: [String]
        $followSearchTypes: [types] = [SEARCH]
        $contentModuleId: String = ""
        $eligibleAbTest: String = ""
        $regions: String = ""
        $userZipCode: String = "0"
        $userCountryCode: String = ""
        $fetchRegionalInfo: Boolean = false
        $isClient: Boolean!
        $fetchSb: Boolean!
        $disableForceFacet: Boolean = false
        $localRecentHistoryItemIds: [String] = []
        $fetchUserRecentHistoryItem: Boolean = false
        $isSbTileCarouselTest: Boolean = false
    ) {
        viewer {
            ...getDomainLinksSb_viewer
            ...SbRespLayout_viewer
            ...detectPageExistsAndRedirect_viewer
        }
    }
`;
